import { render, staticRenderFns } from "./SourceCoverMobile.vue?vue&type=template&id=40c10f0f&scoped=true&"
import script from "./SourceCoverMobile.vue?vue&type=script&lang=js&"
export * from "./SourceCoverMobile.vue?vue&type=script&lang=js&"
import style0 from "./SourceCoverMobile.vue?vue&type=style&index=0&id=40c10f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c10f0f",
  null
  
)

export default component.exports